export default "__VITE_ASSET__C1Go8fQJ__"